import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetch } from "@/lib/hooks";
import { da, fmtDate } from "@/lib/format";
import { Empty, Loading, PageHeader, Panel, StatusBadge, Table, cellCls, rowCls } from "@/components/common";

const FILTERS = [["", "Actifs"], ["brouillon", "Brouillons"], ["envoye", "Présentés"], ["accepte", "Acceptés"], ["refuse", "Refusés"]];

export default function Quotes() {
  const [status, setStatus] = useState("");
  const nav = useNavigate();
  const { data, loading } = useFetch<any[]>(`/quotes?status=${status}`);
  return (
    <div>
      <PageHeader eyebrow="Diagnostic & chiffrage" title="Devis" />
      <div className="mb-4 flex flex-wrap gap-2">
        {FILTERS.map(([v, l]) => (
          <button key={v} onClick={() => setStatus(v)} className={`h-9 rounded-sm border px-4 text-sm transition-colors ${status === v ? "border-primary bg-primary/10" : "border-border hover:bg-accent"}`} data-testid={`quotes-filter-${v || "active"}`}>{l}</button>
        ))}
      </div>
      <Panel>
        {loading ? <Loading /> : !data?.length ? <Empty text="Aucun devis. Créez-en un depuis une réception." /> : (
          <Table head={["N°", "Version", "Véhicule", "Client", "Total TTC", "Créé", "Statut"]} testId="quotes-table">
            {data.map((q) => (
              <tr key={q.id} className={rowCls} onClick={() => nav(`/devis/${q.id}`)} data-testid={`quote-row-${q.id}`}>
                <td className={`${cellCls} font-mono-data font-semibold`}>{q.number}</td>
                <td className={cellCls}>v{q.version}</td>
                <td className={`${cellCls} font-mono-data`}>{q.plate}</td>
                <td className={cellCls}>{q.client_name}</td>
                <td className={`${cellCls} font-mono-data`}>{da(q.totals.ttc)}</td>
                <td className={`${cellCls} text-muted-foreground`}>{fmtDate(q.created_at)}</td>
                <td className={cellCls}><StatusBadge status={q.status} /></td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
